<script setup lang="ts">
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Camera, LocateFixed, ShieldCheck, Truck } from "lucide-vue-next";
import { demoLogin, loadProfile } from "@/lib/session";

const router = useRouter();
const route = useRoute();
const nickname = ref("验收司机");
const loading = ref(false);
const error = ref("");

async function login() {
  loading.value = true; error.value = "";
  try {
    await demoLogin(nickname.value);
    await loadProfile();
    await router.replace(String(route.query.redirect || "/"));
  } catch (cause) {
    error.value = cause instanceof Error ? cause.message : "登录失败";
  } finally { loading.value = false; }
}
</script>

<template>
  <section class="login-page">
    <div class="brand-mark"><Truck :size="38" /></div>
    <h1>HaulGauge</h1>
    <p class="subtitle">货车真实能耗实测<br />顺路领任务，停车再打卡，驾驶中无需操作</p>
    <label class="field"><span>微信昵称</span><input v-model="nickname" class="input" maxlength="30" /></label>
    <div class="permission-list">
      <div class="permission-item"><Camera :size="21" /><span><b>相机权限</b><br />用于实时拍摄行驶证、仪表盘和道路，任务照片不开放相册选择。</span></div>
      <div class="permission-item"><LocateFixed :size="21" /><span><b>始终允许位置</b><br />起点打卡后持续记录路线；若只允许使用期间定位，后台轨迹可能不完整。</span></div>
      <div class="permission-item"><ShieldCheck :size="21" /><span><b>数据仅用于审核</b><br />轨迹和车辆资料只用于任务合格核验与能耗模型校准。</span></div>
    </div>
    <p v-if="error" class="error-banner">{{ error }}</p>
    <button class="btn btn-primary btn-block" :disabled="loading || !nickname.trim()" @click="login">
      {{ loading ? "正在登录…" : "微信一键登录（在线验收）" }}
    </button>
    <p class="tiny muted" style="text-align:center;line-height:1.6">当前为验收登录。配置微信小程序 AppID/Secret 后，API 将直接使用 wx.login 的 code 换取身份。</p>
  </section>
</template>
